import type { ImpersonationCandidate as ImpersonationCandidateRow } from "@/features/admin/api/admin.types";

/**
 * Who a support session may be opened AS.
 *
 * A ONE-LINE FILTER WITH A NAME, and the name is the point. Inline in the component it was
 * missing entirely: the hint under the field promised "Kendi hesabınıza geçemezsiniz" while the
 * list offered the signed-in account like any other row, and picking it produced a server
 * refusal that read like a fault. A control that offers a choice it will then refuse teaches
 * people the product is unreliable — a more expensive lesson than the missing filter.
 *
 * The same rule once lived in the chat picker; it went when a conversation with oneself became
 * allowed there. Here it still holds: nobody opens a support session as themselves.
 */
export interface ImpersonationCandidate {
  id: string;
  primaryEmail: string;
  username?: string | null;
}

export function impersonationCandidates<T extends ImpersonationCandidate>(
  rows: readonly T[],
  meId: string | null | undefined,
): T[] {
  // `null` when the session has not loaded: nothing is excluded rather than everything, because
  // an empty picker is indistinguishable from "no accounts exist" and sends somebody looking.
  if (!meId) return [...rows];
  return rows.filter((row) => row.id !== meId);
}

/**
 * Adayın ikinci satırı: «Filo Müdürlüğü · Filo Yöneticisi, Rapor Dışa Aktarıcı». Herkesin taşıdığı temel «Çalışan»
 * rolü, yanında başka rol varken yazılmıyor — ayırt eden şey departman rolü; tek rolü oysa o yazılıyor.
 */
export function candidateDetail(user: ImpersonationCandidateRow): string | null {
  const business = user.roles.filter((role) => role.code !== "EMPLOYEE");
  const roles = (business.length > 0 ? business : user.roles).map((role) => role.name).join(", ");
  const place = user.unitName ?? user.jobTitleName;
  const parts = [place, roles].filter((part): part is string => Boolean(part));
  return parts.length > 0 ? parts.join(" · ") : null;
}
